import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const masterdataModule: ForqModuleManifest = {
  id: 'masterdata',
  name: 'Stammdaten',
  description: 'Artikel, Dienstleistungen und Lieferanten verwalten',
  version: '0.1.0',
  route: '/artikel',
  category: 'masterdata',
  status: 'development',
  requiredPermissions: ['masterdata.view'],
  features: [
    'masterdata.articles',
    'masterdata.services',
    'masterdata.suppliers',
  ],
  navigation: [
    { id: 'masterdata.articles.primary', label: 'Artikel', route: '/artikel', placement: 'primary', order: 30, icon: 'artikel' },
    { id: 'masterdata.services.primary', label: 'Dienstleistungen', route: '/dienstleistungen', placement: 'primary', order: 31, icon: 'dienstleistungen' },
    { id: 'masterdata.suppliers.primary', label: 'Lieferanten', route: '/lieferanten', placement: 'primary', order: 32, icon: 'lieferanten' },
    { id: 'masterdata.launcher', label: 'Stammdaten', route: '/artikel', placement: 'launcher', order: 30, icon: 'artikel' },
  ],
};

export const masterdataFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'masterdata.articles', moduleId: 'masterdata', name: 'Artikel',
    description: 'Artikel, Ersatzteile, Preise und Bestandsparameter', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['masterdata.articles.view'], uiSlots: [], emits: ['masterdata.item.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'masterdata.services', moduleId: 'masterdata', name: 'Dienstleistungen',
    description: 'Wiederverwendbare Dienstleistungen und Verkaufspreise', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['masterdata.services.view'], uiSlots: [], emits: ['masterdata.item.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'masterdata.suppliers', moduleId: 'masterdata', name: 'Lieferanten',
    description: 'Lieferantenstamm und lieferantenspezifische Artikel', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['masterdata.suppliers.view'], uiSlots: [], emits: ['masterdata.supplier.changed'], listensTo: ['tenant.changed'],
  },
];
